module.exports = __webpack_public_path__ + "img/img35.0334eed2.png";